(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rufftail-cart-reassurance"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const source = document.querySelector('[data-rt-cart-reassurance-source]');
    const template = source && source.querySelector('[data-rt-cart-reassurance]');
    if (!template) return;

    const placeReassurance = () => {
      document.querySelectorAll('.rf-cart__checkout-note').forEach((checkoutNote) => {
        if (checkoutNote.querySelector('[data-rt-cart-reassurance]')) return;
        checkoutNote.insertAdjacentElement('afterbegin', template.cloneNode(true));
      });
    };

    placeReassurance();
    const cartRoot = document.querySelector('cart-items.rf-cart');
    if (cartRoot) {
      new MutationObserver(placeReassurance).observe(cartRoot, { childList: true, subtree: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rufftail-cro-confidence"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function closeDialog(dialog) {
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    }

    function setupConfidencePanel(panel) {
      if (panel.dataset.rtOrderDetailsReady === 'true') return;
      panel.dataset.rtOrderDetailsReady = 'true';

      const productForm = document.querySelector('[data-product-form]');
      if (productForm && !(window.Shopify && window.Shopify.designMode)) {
        productForm.insertAdjacentElement('afterend', panel);
      }

      const trigger = panel.querySelector('[data-rt-order-details-open]');
      const dialog = panel.querySelector('[data-rt-order-details-dialog]');
      if (!trigger || !dialog) return;

      trigger.addEventListener('click', () => {
        document.documentElement.classList.add('rt-order-details-is-open');
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        dialog.querySelector('[data-rt-order-details-close]')?.focus();
      });

      dialog.querySelectorAll('[data-rt-order-details-close]').forEach((button) => {
        button.addEventListener('click', () => closeDialog(dialog));
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog(dialog);
      });

      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('rt-order-details-is-open');
        trigger.focus();
      });

      dialog.addEventListener('cancel', () => {
        document.documentElement.classList.remove('rt-order-details-is-open');
      });
    }

    function initializeConfidencePanels() {
      document.querySelectorAll('[data-rt-cro-section]').forEach(setupConfidencePanel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeConfidencePanels, { once: true });
    } else {
      initializeConfidencePanels();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rufftail-cro-enhancements"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-rt-cro-enhancements]');
    if (!root) return;

    const guideLabel = root.dataset.guideLabel;
    const guideSummaries = document.querySelectorAll('.rufftail-accordion summary');
    guideSummaries.forEach((summary) => {
      const label = summary.querySelector('span');
      if (label && /Feeding Guide|Size Guide|Product Guide/i.test(label.textContent)) {
        label.textContent = guideLabel;
      }
    });

    const emptyReviews = document.querySelectorAll('.rufftail-product__review-empty');
    emptyReviews.forEach((emptyReview) => {
      const reviewRow = emptyReview.closest('.rufftail-product__reviews');
      if (reviewRow) reviewRow.hidden = true;
    });

    if (emptyReviews.length > 0) {
      document.querySelectorAll('.rufftail-accordion').forEach((accordion) => {
        const summary = accordion.querySelector('summary');
        if (summary && /^Reviews$/i.test(summary.textContent.replace('+', '').trim())) {
          accordion.hidden = true;
        }
      });
    }

    const isWalkProduct = root.dataset.isWalkProduct === 'true';
    if (isWalkProduct) {
      document.querySelectorAll('.rufftail-related-products').forEach((rail) => {
        rail.hidden = true;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
